import React, { useEffect, useRef } from 'react';

export default function WinnerName() {
  const nameRef = useRef(null);

  useEffect(() => {
    const element = nameRef.current;
    const correctTranslation = () => {
      // Keep Google's wrapper nodes intact so "Show original" can restore them.
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const corrected = node.data
          .replace(/\bDmitr(?:iy|y|i)\b/g, 'Dmytro')
          .replace(/\bObe[a-z]+uk\b/gi, 'Obeshchuk');
        if (node.data !== corrected) node.data = corrected;
      }
    };
    const observer = new MutationObserver(correctTranslation);
    observer.observe(element, { childList: true, characterData: true, subtree: true });
    correctTranslation();
    return () => observer.disconnect();
  }, []);

  return <span ref={nameRef} className="disp_contents">Дмитрий Обещук</span>;
}
